var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeItems.length > 0 || _vm.isEditable
    ? _c(
        "bulma-table",
        {
          staticClass: "table fixed-layout is-narrow",
          attrs: {
            columns: _vm.columns,
            "total-rows": _vm.totalRows,
            "show-footer": true,
            "sort-column": _vm.filter.sortColumn,
            "sort-order": _vm.filter.sortOrder,
            draggable: false,
            "show-pagination": false,
            "is-title-checkable": _vm.isEditable && _vm.activeItems.length > 0,
            "title-checkbox-location": "front",
            "is-title-checked": _vm.selectAllChecked,
            "header-has-no-border": true,
            "header-height": 3,
          },
          on: {
            "title-checkbox-changed": _vm.selectAllItems,
            pageChanged: _vm.onPageChange,
            sort: _vm.sort,
          },
        },
        [
          _c("template", { slot: "colgroup" }, [
            _c("colgroup", [
              _vm.isEditable && _vm.activeItems.length > 0
                ? _c("col", { staticClass: "width-3" })
                : _vm._e(),
              _c("col", { class: `width-${_vm.columns[0].width}` }),
              _c("col", {
                class: `width-${_vm.columns[1].width} has-border-right-3 pr-5`,
              }),
              _c("col", {
                class: `width-${_vm.columns[2].width} has-border-right-3 pr-5`,
              }),
              _c("col", { class: `width-${_vm.columns[3].width}` }),
              _vm.isEditable
                ? _c("col", { class: `width-${_vm.columns[4].width}` })
                : _vm._e(),
            ]),
          ]),
          _c("template", { slot: "header" }, [
            _c(
              "tr",
              {
                staticClass: "is-size-6 height-3",
                class: `assessment-header-background-${_vm.$theme.name}`,
              },
              [
                _c(
                  "th",
                  {
                    staticClass: "has-vertical-middle has-text-weight-normal",
                    attrs: { colspan: _vm.itemDescColspan },
                  },
                  [_vm._v(" " + _vm._s(_vm.titleItemType) + " ")]
                ),
                _c(
                  "th",
                  {
                    staticClass: "has-vertical-middle has-text-weight-normal",
                    attrs: { colspan: _vm.quotedColspan },
                  },
                  [_vm._v(" Quoted ")]
                ),
                _c(
                  "th",
                  {
                    staticClass:
                      "left-right-items has-vertical-middle has-text-weight-normal",
                    attrs: { colspan: _vm.authorisedColspan },
                  },
                  [
                    _c("div", { staticClass: "left-item mr-4" }, [
                      _c("span", [_vm._v("Authorised")]),
                    ]),
                  ]
                ),
                !_vm.editAuthorisedMode ? _c("th") : _vm._e(),
              ]
            ),
          ]),
          _vm._l(_vm.activeItems, function (item, index) {
            return _c(
              "tr",
              {
                key: item.quoteItemId,
                staticClass: "height-3 has-border-bottom-5",
                class: [
                  item.isQuoteItemDeleted ? "strike-through-line" : "",
                  `assessment-row-background-${_vm.$theme.name}`,
                ],
              },
              [
                _vm.isEditable
                  ? _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-centered is-content-width no-strike-through-line",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-curve p-smooth m-0 p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.isSelected,
                                  expression: "item.isSelected",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(item.isSelected)
                                  ? _vm._i(item.isSelected, null) > -1
                                  : item.isSelected,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = item.isSelected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "isSelected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "isSelected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "isSelected", $$c)
                                    }
                                  },
                                  function ($event) {
                                    return _vm.selectChanged(index, item)
                                  },
                                ],
                              },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon mdi mdi-check" }),
                              _c("label"),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle itemdesc-input" },
                  [
                    _c("div", [
                      !_vm.editQuotedMode && !_vm.editAuthorisedMode
                        ? _c("span", { staticClass: "mr-3" }, [
                            _c(
                              "span",
                              {
                                staticClass: "tooltip",
                                attrs: { "data-tooltip": "New Item" },
                              },
                              [
                                _vm.isItemNew(item)
                                  ? _c("i", {
                                      staticClass:
                                        "has-text-success mdi-20px mdi mdi-arrow-right-box",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "tooltip",
                                attrs: { "data-tooltip": "Modified Item" },
                              },
                              [
                                _vm.isItemValueIncreased(item)
                                  ? _c("i", {
                                      staticClass:
                                        "has-text-warning mdi-20px mdi mdi-arrow-up-box",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "tooltip",
                                attrs: { "data-tooltip": "Modified Item" },
                              },
                              [
                                _vm.isItemValueDecreased(item)
                                  ? _c("i", {
                                      staticClass:
                                        "has-text-warning mdi-20px mdi mdi-arrow-down-box",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      item.isAdded
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.itemDesc,
                                expression: "item.itemDesc",
                              },
                            ],
                            staticClass:
                              "input has-vertical-middle has-vertical-middle",
                            class: [
                              _vm.$v.activeItems.$each[index].itemDesc.required
                                ? ""
                                : "is-danger",
                            ],
                            attrs: { placeholder: "Item Description" },
                            domProps: { value: item.itemDesc },
                            on: {
                              change: function ($event) {
                                return _vm.updateAssessmentItem(index, item)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "itemDesc", $event.target.value)
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(item.itemDesc))]),
                      item.itemComment
                        ? _c(
                            "div",
                            { staticClass: "help is-primary height-1" },
                            [
                              _c(
                                "span",
                                { staticClass: "has-text-weight-bold" },
                                [_vm._v("Comment: ")]
                              ),
                              _c("span", [_vm._v(_vm._s(item.itemComment))]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-centered" },
                  [
                    _vm.isEditable && !item.isQuoteItemDeleted
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-curve p-smooth m-0 p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.reportOnly,
                                  expression: "item.reportOnly",
                                },
                              ],
                              attrs: {
                                disabled: !_vm.canMakeReportOnly(item),
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(item.reportOnly)
                                  ? _vm._i(item.reportOnly, null) > -1
                                  : item.reportOnly,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = item.reportOnly,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "reportOnly",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "reportOnly",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "reportOnly", $$c)
                                    }
                                  },
                                  function ($event) {
                                    return _vm.updateAssessmentItem(index, item)
                                  },
                                ],
                              },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon mdi mdi-check" }),
                              _c("label"),
                            ]),
                          ]
                        )
                      : _c("span", { staticClass: "icon has-text-info" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: [item.reportOnly ? "mdi-check" : ""],
                          }),
                        ]),
                  ]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-right money-input",
                  },
                  [
                    item.submittedItem
                      ? _c(
                          "div",
                          [
                            _vm.editQuotedMode && !item.isQuoteItemDeleted
                              ? _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right has-vertical-middle",
                                  class: _vm.reportOnlyColorClass(
                                    item.submittedItem
                                  ),
                                  attrs: { minus: true, precision: 2 },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateAssessmentItem(
                                        index,
                                        item
                                      )
                                    },
                                  },
                                  model: {
                                    value: item.submittedItem.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item.submittedItem,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "item.submittedItem.value",
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "relative-container" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatNumber(
                                            item.submittedItem.reportOnly
                                              ? 0
                                              : item.submittedItem.value,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]),
                                    item.submittedItem.reportOnly
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "reported-value is-size-7",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "(" +
                                                  _vm.$filters.formatNumber(
                                                    item.submittedItem.value,
                                                    _vm.$userInfo.locale
                                                  ) +
                                                  ")"
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                          ],
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-right money-input",
                    class: [
                      item.isQuoteItemDeleted
                        ? ""
                        : _vm.tableCellColorClass(
                            item.authorisedItem,
                            item.submittedItem
                          ),
                    ],
                  },
                  [
                    item.authorisedItem
                      ? _c(
                          "div",
                          {
                            class: _vm.tableCellTextColorClass(
                              item.authorisedItem,
                              item.submittedItem
                            ),
                          },
                          [
                            _vm.editAuthorisedMode && !item.isQuoteItemDeleted
                              ? _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right has-vertical-middle",
                                  class: [
                                    _vm.reportOnlyColorClass(
                                      item.authorisedItem
                                    ),
                                    _vm.tableCellTextColorClass(
                                      item.authorisedItem,
                                      item.submittedItem
                                    ),
                                  ],
                                  attrs: { minus: true, precision: 2 },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateAssessmentItem(
                                        index,
                                        item
                                      )
                                    },
                                  },
                                  model: {
                                    value: item.authorisedItem.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item.authorisedItem,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "item.authorisedItem.value",
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "relative-container" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatNumber(
                                            item.authorisedItem.reportOnly
                                              ? 0
                                              : item.authorisedItem.value,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]),
                                    item.authorisedItem.reportOnly
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "reported-value is-size-7",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "(" +
                                                  _vm.$filters.formatNumber(
                                                    item.authorisedItem.value,
                                                    _vm.$userInfo.locale
                                                  ) +
                                                  ")"
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                          ],
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                ),
                _vm.isEditable
                  ? _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-centered is-content-width no-strike-through-line",
                      },
                      [
                        _c("div", { staticClass: "icon-container" }, [
                          _vm.editAuthorisedMode || _vm.editQuotedMode
                            ? _c("div", [
                                !item.isQuoteItemDeleted &&
                                item.isDeleted !== true &&
                                item.deleted !== true
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-ghost is-small is-inverted tooltip has-text-grey-lighter",
                                        attrs: {
                                          disabled:
                                            _vm.value.readOnly ||
                                            item.isQuoteItemDeleted,
                                          "data-tooltip": "Delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteItemAuthorise(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-small" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-delete mdi-24px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                item.isQuoteItemDeleted
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-info is-small is-inverted has-vertical-middle",
                                        on: {
                                          click: function ($event) {
                                            return _vm.undoDeleteItem(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-symbols-rounded is-clickable",
                                            on: {
                                              mouseenter: function ($event) {
                                                return $event.target.classList.add(
                                                  "has-text-danger"
                                                )
                                              },
                                              mouseleave: function ($event) {
                                                return $event.target.classList.remove(
                                                  "has-text-danger"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" delete ")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm.activeItems.length === 0
            ? _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "mt-3 mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("span", { attrs: { icon: "icon is-large" } }, [
                        _c("i", {
                          staticClass: "mdi mdi-48px mdi-emoticon-sad",
                        }),
                      ]),
                      _c("p", [_vm._v("No Item available in this category")]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _c("template", { slot: "footer" }, [
            _c("tr", { staticClass: "height-4" }, [
              _c(
                "td",
                {
                  staticClass: "has-vertical-middle",
                  attrs: { colspan: _vm.itemDescColspan },
                },
                [
                  _vm.isEditable
                    ? _c("div", { staticClass: "left-item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-info is-outlined has-vertical-middle",
                            attrs: { "data-tooltip": "add item" },
                            on: {
                              click: function ($event) {
                                return _vm.addItem()
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "is-size-7" }, [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", { staticClass: "mdi mdi-plus" }),
                              ]),
                              _c("span", [_vm._v("Add Item")]),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "td",
                {
                  staticClass: "has-text-right has-vertical-middle",
                  attrs: { colspan: _vm.quotedColspan },
                },
                [
                  _c("div", [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "Quoted " + _vm._s(_vm.titleItemType) + " Totals:"
                      ),
                    ]),
                    _c("span", { staticClass: "has-text-weight-bold" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm.$filters.formatNumber(
                              _vm.quoteTotal,
                              _vm.$userInfo.locale
                            )
                          )
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "td",
                {
                  staticClass: "has-text-right has-vertical-middle",
                  attrs: {
                    colspan: _vm.editAuthorisedMode
                      ? _vm.authorisedColspan - 1
                      : _vm.authorisedColspan,
                  },
                },
                [
                  _c("div", [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "Authorised " + _vm._s(_vm.titleItemType) + " Totals:"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        class: _vm.totalAuthorisedColorClass,
                      },
                      [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.$filters.formatNumber(
                                _vm.authorisedTotal,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c("td"),
            ]),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }